export default {"src":"/_next/static/media/bg.9bffe418.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};